import { PresetItemFormValue } from 'pages/Presets/PresetsCreate/PresetsCreateForm/PresetsCreateForm';
import { PresetItem } from 'types/embedded/preset';

export const mapPresetItemToFormValue = (
  item: PresetItem,
  defaultDirectionId: string,
): PresetItemFormValue => ({
  id: item['@id'],
  direction: item.direction?.['@id'] ?? defaultDirectionId,
  amount: item.amount,
  badge: item.badge?.['@id'] ?? null,
  description: item.description ?? null,
});
